export default "__VITE_ASSET__C68yawNW__"